import SaveTheDateConfigurator from './SaveTheDateConfigurator';

export default SaveTheDateConfigurator;
